import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Sobre from './pages/Sobre';
import Visao from './pages/Visao';
import Contato from './pages/Contato';
import NossaHistoria from './pages/NossaHistoria';
import ApresentacaoComercial from './pages/ApresentacaoComercial';
import Servicos from './pages/Servicos';
import Produtos from './pages/Produtos';

function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Header />
        <div className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/sobre" element={<Sobre />} />
            <Route path="/visao" element={<Visao />} />
            <Route path="/contato" element={<Contato />} />

            {/* Quem Somos */}
            <Route path="/nossa-historia" element={<NossaHistoria />} />
            <Route path="/apresentacao-comercial" element={<ApresentacaoComercial />} />

            {/* Produtos */}
            <Route path="/produtos" element={<Produtos/>} />


            {/* Serviços */}
            <Route path="/servicos" element={<Servicos />} />

            
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
